// src/pages/ExportDemo.jsx
import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import ExportButtons from "../components/ExportButtons";

export default function ExportDemo() {
  const [user, setUser] = useState(null);
  const [chatID, setChatID] = useState(""); // escribe aquí un chatID válido (ej: 56981363182)
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const signIn = async () => {
    try {
      const auth = getAuth();
      await signInWithPopup(auth, new GoogleAuthProvider());
    } catch (error) {
      console.error("Error signing in:", error);
      alert("Error al iniciar sesión: " + error.message);
    }
  };

  const signOut = async () => {
    try {
      const auth = getAuth();
      await auth.signOut();
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: 24 }}>
        <h2>Cargando...</h2>
      </div>
    );
  }

  if (!user) {
    return (
      <div style={{ padding: 24 }}>
        <h2>Acceso restringido</h2>
        <p>Inicia sesión para exportar datos.</p>
        <button 
          onClick={signIn}
          style={{
            padding: "10px 20px",
            fontSize: 16,
            backgroundColor: "#4285f4",
            color: "white",
            border: "none",
            borderRadius: 4,
            cursor: "pointer"
          }}
        >
          Iniciar sesión con Google
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: 24, display: "grid", gap: 16, maxWidth: 600 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1>Export Demo</h1>
        <button 
          onClick={signOut}
          style={{
            padding: "8px 16px",
            fontSize: 14,
            backgroundColor: "#dc3545",
            color: "white",
            border: "none",
            borderRadius: 4,
            cursor: "pointer"
          }}
        >
          Cerrar sesión
        </button>
      </div>
      
      <div style={{ padding: 16, backgroundColor: "#f8f9fa", borderRadius: 8 }}>
        <p><strong>Usuario:</strong> {user.email}</p>
        <p><strong>UID:</strong> <code>{user.uid}</code></p>
      </div>

      <div>
        <label style={{ display: "block", marginBottom: 8 }}>
          <strong>Chat ID:</strong>
        </label>
        <input 
          value={chatID} 
          onChange={(e) => setChatID(e.target.value)} 
          placeholder="Ej: 56981363182"
          style={{
            width: "100%",
            padding: 8,
            fontSize: 14,
            border: "1px solid #ddd",
            borderRadius: 4
          }}
        />
      </div>

      <ExportButtons clienteID={user.uid} chatID={chatID} />
      
      <div style={{ marginTop: 16, padding: 16, backgroundColor: "#fff3cd", borderRadius: 8 }}>
        <strong>💡 Tips:</strong>
        <ul style={{ marginTop: 8 }}>
          <li>Establece un <code>chatID</code> válido para exportar mensajes</li>
          <li>Sin chatID, solo puedes exportar la lista de chats</li>
          <li>Los archivos se descargan automáticamente</li>
        </ul>
      </div>
    </div>
  );
}